import { IAPProductId } from '../../app/iap/types';
import { PiggyBankTier, type PiggyBankTierConfigMap } from './types';

export const MIN_PIGGY_BANK_LEVEL = 0;
export const PIGGY_BANK_LEVEL_REWARD = 100;
export const PIGGY_BANK_FAIL_STREAK_LIMIT = 1;

export const PIGGY_BANK_TIER_CONFIG_MAP: PiggyBankTierConfigMap = {
  [PiggyBankTier.Legacy]: {
    coinsPerLevel: 100,
    maxCoins: 3000,
    durationHours: null,
    iap: IAPProductId.PiggyBank,
    uiValue: 120,
    assetBundle: 'piggybankNormal',
  },
  [PiggyBankTier.Normal]: {
    coinsPerLevel: 120,
    maxCoins: 3000,
    durationHours: 168,
    iap: IAPProductId.PiggyBank,
    uiValue: 125,
    assetBundle: 'piggybankNormal',
  },
  [PiggyBankTier.Silver]: {
    coinsPerLevel: 240,
    maxCoins: 6000,
    durationHours: 120,
    iap: IAPProductId.PiggyBankSilver,
    uiValue: 140,
    assetBundle: 'piggybankSilver',
  },
  [PiggyBankTier.Gold]: {
    coinsPerLevel: 500,
    maxCoins: 12500,
    durationHours: 120,
    iap: IAPProductId.PiggyBankGold,
    uiValue: 160,
    assetBundle: 'piggybankGold',
  },
  [PiggyBankTier.Opal]: {
    coinsPerLevel: 1000,
    maxCoins: 25000,
    durationHours: 120,
    iap: IAPProductId.PiggyBankOpal,
    uiValue: 165,
    assetBundle: 'piggybankOpal',
  },
  [PiggyBankTier.Diamond]: {
    coinsPerLevel: 2200,
    maxCoins: 55000,
    durationHours: 120,
    iap: IAPProductId.PiggyBankDiamond,
    uiValue: 180,
    assetBundle: 'piggybankDiamond',
  },
};

// We could have simply used a number for the tier, but like this we can potentially support changes in the setup. 
// For example, what if we want another tier between normal and silver? 
// By saving the enum in the state and having this array, we can keep the player's current progression 
export const PIGGY_BANK_TIER_PROGRESSION: PiggyBankTier[] = [
  PiggyBankTier.Normal,
  PiggyBankTier.Silver,
  PiggyBankTier.Gold,
  PiggyBankTier.Opal,
  PiggyBankTier.Diamond,
];